import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Shield, TrendingUp } from "lucide-react";

interface AIPerformanceBadgeProps {
  violationsPrevented: number;
  totalAnalyses: number;
}

export const AIPerformanceBadge = ({ violationsPrevented, totalAnalyses }: AIPerformanceBadgeProps) => {
  return (
    <Card className="bg-gradient-to-br from-primary/5 via-primary/10 to-primary/5 border-primary/20">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">AI-Powered Protection</CardTitle>
          </div>
          <Badge variant="secondary" className="gap-1">
            <Shield className="h-3 w-3" />
            Active
          </Badge>
        </div>
        <CardDescription>Real-time compliance risk assessment</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Violations Prevented</p>
            <div className="flex items-baseline gap-2">
              <p className="text-3xl font-bold text-primary">{violationsPrevented}</p>
              <Shield className="h-5 w-5 text-primary" />
            </div>
            <p className="text-xs text-muted-foreground">Zero NCAA violations in AI-approved deals</p>
          </div>
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Deals Analyzed</p>
            <div className="flex items-baseline gap-2">
              <p className="text-3xl font-bold">{totalAnalyses}</p>
              <TrendingUp className="h-5 w-5 text-muted-foreground" />
            </div>
            <p className="text-xs text-muted-foreground">
              {totalAnalyses > 0 ? 'Automated compliance checks' : 'Start analyzing deals'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
